// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__mUagl","formControl":"addForm_formControl__p++iF","list":"addForm_list__02el8","btnWrpper":"addForm_btnWrpper__1CmHH"};